import axios from '@/utils/request'

export default {
  getLaunchBannerList: (data) => axios({ url: '/api/product/pushBanner/list', method: 'post', data }), // 查询Banner列表
  editLaunchBanner: (data) => axios({ url: '/api/product/pushBanner/edit', method: 'post', data }), // 新增/编辑Banner
  editLaunchBannerStatus: (data) => axios({ url: '/api/product/pushBanner/status', method: 'put', data }), // 修改状态
  sortLaunchBanner: (data) => axios({ url: '/api/product/pushBanner/sort', method: 'put', data }), // 修改排序

  getLaunchCollectionList: (data) => axios({ url: '/api/product/pushCollection/list', method: 'post', data }), // 查询集合列表
  editLaunchCollection: (data) => axios({ url: '/api/product/pushCollection/edit', method: 'post', data }), // 新增/编辑集合
  editLaunchCollectionStatus: (data) => axios({ url: '/api/product/pushCollection/status', method: 'put', data }), // 修改状态
  sortLaunchCollection: (data) => axios({ url: '/api/product/pushCollection/sort', method: 'put', data }), // 修改排序
  getLaunchCollectionConfig: () => axios({ url: '/api/product/pushUniversalCode/config', method: 'get' }), // 获取集合配置
  saveLaunchCollectionConfig: (data) => axios({ url: '/api/product/pushUniversalCode/save', method: 'post', data }), // 保存集合配置

  getLaunchVisitList: (data) => axios({ url: '/api/product/pushLead/list', method: 'post', data }), // 查询访问列表
  getLaunchCollectionDropdown: (data) => axios({ url: '/api/product/pushCollection/dropdown', method: 'post', data }), // 查询集合下拉列表
  editLaunchVisitRemark: (data) => axios({ url: '/api/product/pushLead/remark', method: 'put', data }), // 编辑访问备注
  editLaunchVisitFollowStatus: (data) => axios({ url: '/api/product/pushLead/followStatus', method: 'put', data }), // 编辑访问跟进状态
}
